// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/user","layout":false,"id":"1"},"2":{"name":"login","path":"/user/login","parentId":"1","id":"2"},"3":{"name":"list.users-list","icon":"table","path":"users-list","parentId":"ant-design-pro-layout","id":"3"},"4":{"name":"list.device-list","icon":"table","path":"device-list","parentId":"ant-design-pro-layout","id":"4"},"5":{"path":"/","redirect":"/device-list","parentId":"ant-design-pro-layout","id":"5"},"6":{"path":"*","layout":false,"id":"6"},"ant-design-pro-layout":{"id":"ant-design-pro-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import('./EmptyRoute')),
'2': React.lazy(() => import(/* webpackChunkName: "p__user__login__index" */'@/pages/user/login/index.tsx')),
'3': React.lazy(() => import(/* webpackChunkName: "p__users-list__index" */'@/pages/users-list/index.tsx')),
'4': React.lazy(() => import(/* webpackChunkName: "p__device-list__index" */'@/pages/device-list/index.tsx')),
'5': React.lazy(() => import('./EmptyRoute')),
'6': React.lazy(() => import(/* webpackChunkName: "p__404" */'@/pages/404.tsx')),
'ant-design-pro-layout': React.lazy(() => import(/* webpackChunkName: "t__plugin-layout__Layout" */'/Users/wunan/personal/FitNation-web/FitNation-web/src/.umi-production/plugin-layout/Layout.tsx')),
},
  };
}
